const translations: Record<string, string> = {
  "ak_dsp_failed_to_load_data": "Не вдалося завантажити дані",
  "ak_dsp_select_a_station_in_the_top_bar_to_see": "Оберіть станцію у верхній панелі, щоб побачити прогноз.",
  "ak_dsp_trading_schedule": "Торговий графік",
  "ak_dsp_delivery_schedule_and_statuses": "графік відпуску та статуси",
  "ak_dsp_for_the_selected_day": "за обрану добу",
  "ak_dsp_summary": "Підсумки",
  "ak_dsp_until_00": "до {{h}}:00",
  "ak_dsp_cumulative": "накопичувально",
  "ak_dsp_generation_forecast": "Прогноз генерації",
  "ak_dsp_actual_generation": "Факт генерації",
  "ak_dsp_forecast_performance": "Виконання прогнозу",
  "ak_dsp_uploaded_to_mms": "Завантажено на MMS",
  "ak_dsp_kwh": "кВт·год",
  "ak_dsp_by_hours": "За години",
  "ak_dsp_per_day": "За добу",
  "ak_dsp_24_h": "24 год",
};

export default translations;
